<template>
  <div id="homelesson" class="main-wrapper">
    <BottomBar />
    <Login
      v-if="components.login"
      v-on:dismiss="components.login = false"
      v-on:complete="showPay"
    />
    <div v-if="data" :class="{ noscroll: isShowPopup }" class="container">
      <div v-if="data.pay_status == 1" class="msg msg-blue" @click="showDeadlinePopup()">
        <i class="anyteachicon anyteach-clock" />
        <span>{{ deadline.month }} 月 {{ deadline.date }} 日 {{ deadline.time }} 前完成支付</span>
      </div>
      <div v-if="data.pay_status == 2" class="msg msg-red" @click="showCompletePopup()">
        <i class="anyteachicon anyteach-check" />
        <span>已完成支付</span>
      </div>
      <div v-if="data.pay_status == 3" class="msg" @click="showFailurePopup()">课程已失效</div>
      <div v-if="data.pay_status == 4" class="msg" @click="showFailurePopup()">课程已取消</div>
      <div class="top select-wrapper">
        <div class="title">
          <div class="img-container" :style="background(data.user.gravatar)" />
          <h1>
            {{ data.user.name }}的
            <span v-if="data.pax == 1">1 至 2 人</span>
            <span v-else>3 至 8 人</span>拼课
          </h1>
        </div>
        <div class="info">
          <span class="info-item">
            <i class="anyteachicon anyteach-book" />
            <span>{{ data.regular }} 次</span>
            <span v-if="data.extra">+ 赠送 {{ data.extra }} 次</span>
          </span>
          <span class="info-item" @click="showTeacherTypePopup()">
            <i class="anyteachicon anyteach-graduation-cap" />
            <span v-if="data.teacher_type == 1">中教 + 外教</span>
            <span v-else>全外教课</span>
          </span>
          <span class="info-item">
            <i class="anyteachicon anyteach-calendar" />
            <span>
              每周
              {{ Object.keys(data.timeslot).filter(item => data.timeslot[item].isSelected).length }}
              次
              <i class="anyteachicon anyteach-guanbi" />
              {{ data.duration }} 小时
            </span>
          </span>
        </div>
      </div>
      <div v-if="data.sub_user[0]" class="select-wrapper">
        <h2>参与人</h2>
        <div v-for="item in data.sub_user" :key="item.u_id" class="sub-user">
          <div class="left">
            <div class="img-container" :style="background(item.gravatar)" />
            <div class="text-container">
              <h1 v-if="item.u_id == user.user_id">我</h1>
              <h1 v-else>{{ item.name }}</h1>
              <h2>
                <i class="anyteachicon anyteach-check-circle" />
                已支付 ¥{{ data.price }}
              </h2>
            </div>
          </div>
          <div
            v-if="
              item.isFirstTime &&
                (data.user.user_id == user.user_id ||
                  data.sub_user.filter(item => item.u_id == user.user_id))
            "
            class="right"
            @click="showEmptyPopup()"
          >
            <div v-if="item.r_type == data.user_type" class="label">首单用户</div>
            <span v-if="item.r_type == 1 && data.user_type == 1">已减 ¥{{ item.r_content }}</span>
            <span v-if="item.r_type == 2 && data.user_type == 2">已赠 1 张学习券</span>
          </div>
        </div>
      </div>
      <div v-else id="no-friends-msg" class="select">
        <div
          v-if="data.user_type == 1 && data.pay_status == 1"
          class="msg"
          @click="showEmptyPopup()"
        >
          还没有好友加入课程，邀请首单好友立减 10%
        </div>
      </div>
      <div class="select-wrapper">
        <h2>开课时间</h2>
        <h3>
          {{ getMoment(data.date[0]).format("M月D日 ddd") }} {{ dateObjOfClasses[0].time }} -
          {{ dateObjOfClasses[0].timeEnd }}
        </h3>
      </div>
      <div id="class-time" class="select-wrapper">
        <h2 class="title-action">
          上课时间
          <span class="button" @click="isShowCalendar = true">查看所有上课日期</span>
        </h2>

        <div v-for="(item, index) in data.timeslot" :key="index">
          <h3 v-if="item.isSelected">每{{ item.name }} {{ item.time }} - {{ item.timeEnd }}</h3>
        </div>
      </div>
      <div class="select-wrapper">
        <h2>上课地点</h2>
        <h3>{{ data.address }}</h3>
      </div>
      <div id="more" :class="{ extraPadding: isExtraPadding }">
        <h2>其他</h2>
        <div v-if="(data.user_type == 1) & (data.pay_status == 1)" class="delete select-wrapper">
          <h3 @click="isShowDelete = true">取消课程</h3>
        </div>
        <div class="select-wrapper">
          <h3 @click="showInfoPopup()">课程须知</h3>
        </div>
        <div class="select-wrapper">
          <h3 @click="showPricesPopup()">拼课价格</h3>
        </div>
        <div class="select-wrapper">
          <router-link to="/progress" tag="h3">学习进度</router-link>
        </div>
        <div class="select-wrapper">
          <router-link to="/contact" tag="h3">联系小管家</router-link>
        </div>
      </div>
      <div v-if="data.user_type == 1 && data.pay_status == 1" id="join" class="join">
        <div class="left">
          <h1>¥{{ data.price }}/人</h1>
          <h2>
            <span v-if="!data.sub_user[0] || (spots > 0 && !reward[0])" @click="showEmptyPopup()">
              <i class="anyteachicon anyteach-info-circle" />
              邀请首单好友加入立减 ¥{{ data.price * 0.1 }}
            </span>
            <span v-if="reward[0] && spots > 0" @click="showEmptyPopup()">
              <i class="anyteachicon anyteach-info-circle" />
              已减 ¥{{ reward.reduce((total, item) => total + parseInt(item.r_content), 0) }}，再邀
              1 人立减 ¥{{ data.price * 0.1 }}
            </span>
            <span v-if="spots == 0 && reward[0]">
              课程已满，共减 ¥{{
                reward.reduce((total, item) => total + parseInt(item.r_content), 0)
              }}
            </span>
            <span v-if="spots == 0 && !reward[0]">课程已满，等待支付</span>
          </h2>
        </div>
        <div
          v-if="data.pax == 1 || (data.pax == 2 && data.sub_user.length >= 2)"
          class="right"
          @click="showPay"
        >
          支付 ¥{{ data.o_price }}
        </div>
        <div v-else class="right disabled" @click="showNotEnoughUsersPopup()">
          支付 ¥{{ data.o_price }}
        </div>
      </div>
      <div v-if="data.user_type == 3 && data.pay_status == 1" id="join" class="join">
        <div class="left">
          <h1>¥{{ data.price }}/人</h1>
          <h2 v-if="spots">还有 {{ spots }} 个名额</h2>
          <h2 v-else>课程已满</h2>
        </div>
        <div v-if="spots" class="right" @click="showPay()">加入课程</div>
        <div v-else class="right disabled">无法加入</div>
      </div>
      <Calendar v-if="isShowCalendar" :dates="data.date" @close="isShowCalendar = false" />
      <keep-alive>
        <Pay v-if="isShowPay" :data="data" @success="success()" @close="isShowPay = false" />
      </keep-alive>
    </div>
    <div v-else class="empty">
      <InlineLoading />
    </div>

    <Success v-if="isShowSuccess" @close="refresh()" />
    <ErrorMessage v-if="isShowErrorMessage" @close="isShowErrorMessage = false" />
    <Delete v-if="isShowDelete" @deleted="getData()" @close="isShowDelete = false" />
    <Popup v-if="isShowPopup" :msg="popupMsg" @close="isShowPopup = false" />
  </div>
</template>
<script>
import InlineLoading from "vux/src/components/inline-loading"
import Popup from "@/components/public/Popup.vue"
import Calendar from "@/components/homeclass/dates"
import Pay from "./Pay"
import Success from "./Success"
import Delete from "./Delete"
import ErrorMessage from "@/components/public/notfound"
import BottomBar from "@/components/public/footer"
import Login from "@/components/popup/Login"

export default {
  name: "Homelesson",
  components: {
    InlineLoading,
    Popup,
    Calendar,
    Pay,
    Success,
    ErrorMessage,
    Delete,
    BottomBar,
    Login,
  },
  data() {
    return {
      id: this.$route.params.id,
      data: "",
      dateObjOfClasses: [],
      popupMsg: "",
      isShowPopup: false,
      isShowCalendar: false,
      isShowPay: false,
      isShowSuccess: false,
      isShowErrorMessage: false,
      isShowDelete: false,
      isExtraPadding: false,
      deadline: "",
      reward: "",
      spots: "",
      components: {
        login: false,
      },
    }
  },
  watch: {
    popupMsg: function (val) {
      if (val) this.isShowPopup = true
    },
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    if (process.env.VUE_APP_ENV === "production") {
      if (this.$route.params.r_u_id) {
        if (
          location.href !=
          `${homePageUrl}/homeclass/${this.$route.params.id}&referral=${this.$route.params.r_u_id}`
        ) {
          location.href = `${homePageUrl}/homeclass/${this.$route.params.id}&referral=${this.$route.params.r_u_id}`
        }
      } else {
        if (location.href != `${homePageUrl}/homeclass/${this.$route.params.id}`) {
          location.href = `${homePageUrl}/homeclass/${this.$route.params.id}`
        }
      }
    }
    this.getData()
  },
  methods: {
    showPay() {
      if (!this.$store.state.user.mobile) {
        this.components.login = true
      } else {
        this.isShowPay = true
      }
    },
    success() {
      this.isShowSuccess = true
      this.isShowPay = false
      this.data = ""
    },
    refresh() {
      this.isShowSuccess = false
      this.getData()
    },
    background(url) {
      return `background-image:url(${url})`
    },
    getMoment(date) {
      return this.$moment.utc(date).utcOffset(480)
    },
    showTeacherTypePopup() {
      this.popupMsg = {
        title: "教师搭配",
        content: [
          {
            title: "全外教课",
            content: "每节课都由 AnyTeach 的外教老师授课，提供沉浸式外教英语环境。",
          },
          {
            title: "中教 + 外教",
            content: "一节外教课，一节中教课。中西结合，双管齐下，加强听说读写。",
          },
        ],
      }
    },
    showDeadlinePopup() {
      this.popupMsg = {
        title: "支付须知",
        content: [
          {
            title: "加入课程",
            content: "如果还有名额，开课时间 24 小时前任何人都可以加入课程并支付。",
          },
          {
            title: "课程失效",
            content: "如果发起人未在开课时间 24 小时前完成支付，课程将自动失效、退款。",
          },
        ],
      }
    },
    showCompletePopup() {
      this.popupMsg = {
        title: "支付完成",
        content: [
          {
            content: "当前课程已经完成拼班，无法加入更多新人。",
          },
        ],
      }
    },
    showFailurePopup() {
      this.popupMsg = {
        title: "课程失效/取消",
        content: [
          {
            content: "已经支付的用户将自动获得退款。",
          },
        ],
      }
    },
    showEmptyPopup() {
      this.popupMsg = {
        title: "邀请首单好友",
        content: [
          {
            content:
              "“首单好友”指的是第一次在 AnyTeach 约课平台上支付课程的用户。邀请首单好友加入课程，不论您是发起人或参与人，可以立即获得奖励。",
          },
          {
            title: "发起人",
            content: "邀请首单好友，发起人学费立减 10%。",
          },
          {
            title: "参与人",
            content: "邀请首单好友，立即获得一张 100 元同城拼课学习券。",
          },
        ],
      }
    },
    showPricesPopup() {
      this.popupMsg = {
        title: "同城拼课价格",
        content: [
          {
            content: "<img src='https://cdn.anyteach.cn/img/homeclass/homeclass-price.png'/>",
          },
        ],
      }
    },
    showInfoPopup() {
      this.popupMsg = {
        title: "课程须知",
        content: [
          {
            title: "同城拼课是什么？",
            content:
              "和同城市、同小区小伙伴在家拼课、享受 AnyTeach 教师上门的英语课程。选择合适自己的课时包、定制上课时间地点，任何人都可以发起 1 至 8 人拼课，更可以享受发起人特权：邀请首单好友立减学费 10%。",
          },
          {
            title: "师资力量",
            content:
              "AnyTeach 教学团队的全职签约外教老师均来自于欧美国家，不仅具备多年教学经验，同时也具备国际认可资质，如 TEFL、TESL、TESOL 教学证书等。我们不仅根据教师的学历和证书严格筛选，同时注重其授课能力及综合素养。所有外教须经过严格的笔试、面试、试教、培训等层层筛选方可任教。",
          },
          {
            title: "授课教材",
            content:
              "针对不同年龄段和英语水平，AnyTeach 约课平台选用全球最大教育集团培生教育集团出版的系列教材《SuperTots》、《Longman Welcome to English》，以及外研社与剑桥大学出版社出版的《Interchange》剑桥国际英语教程。",
          },
          {
            title: "支付流程",
            content:
              "参与人先支付、发起人最后支付。<br>1. 小伙伴加入课程、立即支付。<br> 2. 发起人最后支付课程，关闭课程名额。<br>如果是 1 人上课，发起课程后随机支付即可。",
          },
          {
            title: "我可以拼课吗？",
            content:
              "不论是小朋友或是大朋友，不论是 1 人或是 8 人拼班，只要您或好友可以提供上课场所，AnyTeach 教学团队都可以为您指定合适的教师上门授课。<br><br>准备好上课场所，前往 <a class='link' href='//wx.anyteach.cn/#/homeclass/post'>这里</a> 发起拼课。",
          },
          {
            title: "课程可以取消吗？",
            content: "发起人可以在课程开始前 24 小时取消课程，平台将自动为已加入的所有参与人退款。",
          },
          {
            title: "可以更改上课时间吗？",
            content: "每 3 个月，发起人可以联系 AnyTeach 小管家更改一次上课时间。",
          },
          {
            title: "拼课人数怎么设定？",
            content: "您可以根据需求选择 1 至 2 人或 3 至 8 人拼课。",
          },
          {
            title: "如果拼不成怎么办？",
            content:
              "1 至 2 人拼课最少需要 1 人、3 至 8 人拼课最少需要 3 人开课（包含发起人），开课时间 24 小时前如果发起人还未支付，课程将自动失效、退款。",
          },
        ],
      }
    },
    showNotEnoughUsersPopup() {
      this.popupMsg = {
        title: "人数不够",
        content: [{ content: "3 至 8 人拼课，含发起人至少需要 3 人才能支付课程。" }],
      }
    },
    getData() {
      this.$axios({
        url: window.PHP_ROOT + "/index/collage/details",
        method: "POST",
        data: { id: this.$route.params.id },
      }).then(({ data }) => {
        const { code, msg } = data
        if (code == 1000) {
          msg.timeslot = JSON.parse(msg.timeslot)
          this.data = msg
          this.data.date.forEach((item, index) => {
            const date = this.$moment.utc(item).utcOffset(480)
            const time = msg.timeslot[date.format("d")].time
            const timeEnd = msg.timeslot[date.format("d")].timeEnd
            this.dateObjOfClasses.push(
              bus.getDateObj(
                new Date(item),
                time,
                timeEnd
              ),
            )
          })
          this.deadline = bus.getDateObj(
            bus.incrementDate(this.dateObjOfClasses[0].obj, -1),
            this.data.time[0],
          )
          this.spots =
            this.data.pax == 1 ? 1 - this.data.sub_user.length : 7 - this.data.sub_user.length
          this.reward =
            this.data.user_type == 1
              ? this.data.sub_user.filter(
                item => item.isFirstTime && item.r_u_id == this.data.user.user_id,
              )
              : null
          this.isShowErrorMessage =
            this.data.pay_status == 4 && this.data.user_type == 3 ? true : false
          this.initWeChat()
        } else {
          this.isShowErrorMessage = true
        }
        this.$nextTick(() => {
          if (document.getElementById("join")) {
            this.isExtraPadding = true
          }
        })
      }).catch(error => {
        this.isShowErrorMessage = true
      })
    },
    initWeChat() {
      const pax = this.data.pax == 1 ? " 1 至 2 人" : " 3 至 8 人"
      const spots = this.spots
        ? `${this.spots} 个名额 · ${this.deadline.month} 月 ${this.deadline.date} 日 ${this.deadline.time} 截止拼课`
        : "名额已满"
      window.document.title = `${this.data.user.name}的${pax}拼课`
      wx.ready(() => {
        let title, desc, link, imgUrl
        if (this.data.user_type != 3) {
          title = `${this.user.name}邀请你加入 AnyTeach 同城拼课`
          desc = `¥${this.data.price}/人 · ${this.data.regular + this.data.extra} 次课 · ${spots}`
          link = `${window.homePageUrl}/homeclass/${this.data.id}&referral=${this.user.user_id}`
          imgUrl = this.user.gravatar
        } else {
          title = `${this.data.user.name}的 AnyTeach 同城拼课`
          desc = `¥${this.data.price}/人 · ${this.data.regular + this.data.extra} 次课 · ${spots}`
          link = `${window.homePageUrl}/homeclass/${this.data.id}`
          imgUrl = this.data.user.gravatar
        }
        this.$wxShare({ title, desc, link, imgUrl })
      })
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";
@import "../../../../static/css/radio.scss";
@import "../../../../static/css/prog-form.scss";

#homelesson {
  $grey: #999999;
  padding: 5% 5% 0 5%;
  background: white;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  .extraPadding {
    padding-bottom: 85px;
  }
  .button {
    background: none;
  }
  .empty {
    height: 80vh;
  }
  .container {
    .no-border {
      border: none;
    }
  }
  .select-wrapper {
    h3 {
      padding: 5px 0 10px 0;
    }
  }
  #no-friends-msg {
    margin-top: -15px;
  }
  .top {
    padding: 10px 0 10px 0;

    .title {
      display: flex;
      align-items: center;
      h1 {
        font-size: 25px;
        font-weight: 500;
        margin-left: 10px;
        line-height: 1.3;
        @include avenir-demi();
      }
      .img-container {
        min-width: 50px;
        min-height: 50px;
        background-position: center;
        background-size: cover;
        border-radius: 100%;
      }
    }
    .info {
      padding: 20px 0 0 0;
      .info-item {
        font-size: 15px;
        color: $black;
        margin: 0 10px 5px 0;
        word-wrap: none;
        display: inline-block;
        i {
          font-size: 13px;
          margin-right: 3px;
        }
      }
    }
  }
  .sub-user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 15px 0;
    .left {
      display: flex;
      align-items: center;
      .img-container {
        width: 50px;
        height: 50px;
        background-position: center;
        background-size: contain;
        background-color: #eee;
        border-radius: 100%;
        margin-right: 10px;
      }
      h1 {
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 5px;
      }
      h2 {
        font-size: 13px;
        color: $black;
        font-weight: 300;
      }
    }
    .right {
      font-size: 13px;
      color: $black;
      font-weight: 300;
      .label {
        width: auto;
        border: 1px solid $grey;
        color: $grey;
        border-radius: 3px;
        font-weight: 400;
        display: block;
        font-size: 13px;
        text-align: center;
      }
    }
  }
  .join {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    left: 5%;
    bottom: $bottom-bar;
    bottom: $iphone-x-bottom-bar;
    margin-bottom: 15px;
    width: 90%;
    padding: 10px 3%;
    border-radius: 5px;
    background: white;
    box-shadow: $deep-shadow;
    @include avenir();
    .left {
      padding-right: 5px;
      h1 {
        color: $black;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 3px;
        @include avenir-demi();
      }
      h2 {
        color: $black;
        font-weight: 300;
        font-size: 13px;
        line-height: 1.3;
      }
    }
    .right {
      padding: 10px 10px;
      background: $red;
      color: white;
      border-radius: 5px;
      font-size: 13px;
      text-align: center;
      line-height: 1.3;
      @include avenir-demi();
      &:active {
        opacity: 0.7;
      }
    }
    .disabled {
      opacity: 0.7;
    }
  }
  #more {
    h2 {
      font-weight: bold;
      font-size: 13px;
    }
    .select-wrapper {
      margin-bottom: 10px;
      transition: 0.1s;
      &:active {
        opacity: 0.7;
      }
      h3 {
        font-weight: bold;
      }
    }
  }

  #class-time {
    padding-bottom: 15px;
    h3 {
      padding-bottom: 0;
    }
  }
}
</style>
